/*
 * O topo da página de uma categoria: o nome enorme, a descrição e
 * as subcategorias em cartões brancos com o símbolo colorido num quadrado.
 */
import Hero from 'flarum/forum/components/Hero';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
import { forumBool, t } from '../utils/settings';
import { allTags, categorySymbol, sortTags, tagSymbol, tagUrl } from '../utils/tags';
export default class CategoryHero extends Hero {
  className() {
    return 'CanelaCategoryHero';
  }
  style() {
    const color = this.attrs.model.color();
    return color ? {
      '--category-color': color
    } : undefined;
  }
  bodyItems() {
    const items = new ItemList();
    const tag = this.attrs.model;
    const description = tag.description();

    // Etiqueta (tag secundária) com ícone no Flarum: o ícone antes do nome.
    const icon = tag.position() === null ? tagSymbol(tag, 'CanelaCategoryHero-icon') : null;
    items.add('title', m("h1", {
      className: "CanelaCategoryHero-title"
    }, icon, tag.name()), 100);
    if (description) {
      items.add('description', m("p", {
        className: "CanelaCategoryHero-description"
      }, description), 90);
    }
    const children = forumBool('canelaCategoryHeroChildren', true) ? this.children() : [];
    if (children.length) {
      items.add('children', m("ul", {
        className: "CanelaCategoryHero-children",
        "aria-label": t('hero.subcategories')
      }, children.map(child => m("li", null, m(Link, {
        className: "CanelaSubcategoryCard",
        href: tagUrl(child),
        style: child.color() ? {
          '--category-color': child.color()
        } : undefined
      }, m("span", {
        className: "CanelaSubcategoryCard-tile"
      }, categorySymbol(child)), m("span", {
        className: "CanelaSubcategoryCard-name"
      }, child.name()))))), 80);
    }
    return items;
  }
  children() {
    const model = this.attrs.model;
    const children = model.children();
    if (Array.isArray(children)) return sortTags(children.filter(Boolean));

    // A relação só chega com o `include=children` do carregamento da tag, um
    // pedido depois de a página abrir: os cartões apareciam atrasados. As
    // filhas já vêm com o fórum (o flarum/tags carrega as tags com posição),
    // então saem já no primeiro desenho.
    return sortTags(allTags().filter(tag => tag.parent?.() === model));
  }
}
flarum.reg.add('ramon-canela', 'forum/list/CategoryHero', CategoryHero);